export const state = () => ({
    locales: ['en', 'no', 'da', 'nl', 'fi', 'fr', 'de', 'it', 'es', 'sv', 'de_AT', 'de_CH'],
    locale: 'en',
});

export const mutations = {
    SET_LANG(state, locale) {
        if (state.locales.indexOf(locale) !== -1) {
            state.locale = locale;
        }
    },
};
